// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import pfolioEntity from './entities/pfolio.json';
import pfolioMenu from '../pages/pfolio/menu.json';
import pfolioFullForm from '../pages/pfolio/forms/full.json';
import pfolioContextForm from '../pages/pfolio/forms/context.json';
import pfolioMiniForm from '../pages/pfolio/forms/mini.json';
import pfolioLookupForm from '../pages/pfolio/forms/lookup.json';
import pfolioTableView from '../pages/pfolio/views/table.json';
import pfolioStagesView from '../pages/pfolio/views/stages.json';
import pfolioCardsView from '../pages/pfolio/views/cards.json';
import pfolioInlineView from '../pages/pfolio/views/inline.json';
import pfolioBacklogView from '../pages/pfolio/views/backlog.json';
import pfolioSplitView from '../pages/pfolio/views/split.json';
import pfolioCalendarView from '../pages/pfolio/views/calendar.json';
import pfolioDashboardView from '../pages/pfolio/views/dashboard.json';

/** Тип запису «Портфель» зі сторінками пакета: меню, форми та подання з pages/pfolio/. */
export const pfolioDefinition: IRecordTypeDefinition = {
  ...pfolioEntity,
  views: assembleViewSet({
      table: pfolioTableView,
      stages: pfolioStagesView,
      cards: pfolioCardsView,
      inline: pfolioInlineView,
      backlog: pfolioBacklogView,
      split: pfolioSplitView,
      calendar: pfolioCalendarView,
      dashboard: pfolioDashboardView,
  }),
  form: pfolioFullForm,
  forms: { full: pfolioFullForm, context: pfolioContextForm, mini: pfolioMiniForm, lookup: pfolioLookupForm },
  menu: pfolioMenu,
} as IRecordTypeDefinition;
